<template>
  <button 
   class="button"
   :class="additionalClass"
   :disabled="isDisabledButton"
   @click.prevent="handleClick"
  >サムネイルに設定する</button>
</template>

<script>
export default {
  props : {
    isLoading   : {
      default: false
    },
    isDisabled  : {
      default: false
    }
  },

  data(){
    return {
      isDisabledButton  : false,

      additionalClass   : {
        'is-loading'    : false,
      },
    };
  },

  watch : {
    isLoading : {
      handler(value){
        if(value === true){
          this.isDisabledButton = true;
          this.additionalClass['is-loading'] = true;
        }else{
          this.isDisabledButton = false;
          this.additionalClass['is-loading'] = false;
        }
      },
      immediate: true
    },

    isDisabled : {
      handler(value){
        if(value === true){
          this.isDisabledButton = true;
        }else{
          this.isDisabledButton = false;
        }
      },
      immediate: true
    }
  },

  methods : {
    handleClick(){
      this.$emit('onClick');
    }
  },
}
</script>

<style lang="scss">

</style>